export class Roles {
  public static FavoursAdmin: string = "FavoursAdmin";
  public static WaiversAdmin: string = "WaiversAdmin";
  public static IataAdmin: string = "IataAdmin";
}



// WEBPACK FOOTER //
// ./src/app/shared/models/roles.ts